<template>
<div class='card'>
    <div class='card-header'>
        <label class='az-content-label' style='text-transform: none'>Contributions</label>
        <ul class='tx-12 tx-gray-700 s pd-l-20'>
            <li>Non-concessional cap shown does NOT take prior year 'Bring Forward Rule' usage into account</li>
            <li>Excludes any unmatched deposits</li>
            <li>Any excess concessional contributions are treated as non-concessional</li>
        </ul>
    </div>
    <DisclaimerV2 button-style="font-size:12px;margin-left:25px">
      <div style="font-size:12px;max-width:600px">
        The contribution cap figures shown are based on last SMSF annual return lodged and other information available to us.  For accuracy, you will need to review the Member’s MyGov account and super contributions made to any fund up to date.
      </div>
    </DisclaimerV2>
    <div class='card-body' v-loading='loading'>
        <el-tabs class='mg-b-20' type="border-card" v-for='(con,index) in contributions' :key='con.trustee__id'>
            <el-tab-pane>
                <span slot="label"><i class="el-icon-user-solid"></i> {{isSample?'Mr Mike Sample '+(index+1):con.trustee__trustee_name}}</span>
                <div class="table-responsive tx-13">
                    <table class="table mg-b-0">
                        <thead>
                        <tr>
                            <th>Current Year Contributions</th>
                            <th>Concessional</th>
                            <th>Non-Concessional</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>Caps</td>
                            <td>{{currentformats.AUformat(con.concessional_caps)}}</td>
                            <td>{{currentformats.AUformat(con.noncessional_caps)}}</td>
                        </tr>
                        <tr>
                            <td>Cumulative Available Unused Caps</td>
                            <td>{{currentformats.AUformat(con.con_cumulative_ava_unused_cap)}}</td>
                            <td>{{currentformats.AUformat(con.non_con_cumulative_ava_unused_cap)}}</td>
                        </tr>
                        <tr>
                            <td>Contributions made (to this fund)</td>
                            <td>{{currentformats.AUformat(con.concessional_contributions_to_this_fund)}}</td>
                            <td>{{currentformats.AUformat(con.non_concessional_contributions_to_this_fund)}}</td>
                        </tr>
                        <tr>
                            <td>Contributions made (to other funds)</td>
                            <td>{{currentformats.AUformat(con.concessional_contributions_to_other_fund)}}</td>
                            <td>{{currentformats.AUformat(con.non_concessional_contributions_to_other_fund)}}</td>
                        </tr>
                        <tr>
                            <td>Contributions as allocated</td>
                            <td>{{currentformats.AUformat(con.concessional_contributions_as_allocated)}}</td>
                            <td>{{currentformats.AUformat(con.non_concessional_contributions_as_allocated)}}</td>
                        </tr>
                        <tr>
                            <td>Amount above caps</td>
                            <td>{{currentformats.AUformat(con.concessional_amounts_above_caps)}}</td>
                            <td>{{currentformats.AUformat(con.non_concessional_amounts_above_caps)}}</td>
                        </tr>
                        <tr>
                            <td>Available</td>
                            <td>{{currentformats.AUformat(con.concessional_available_total)}}</td>
                            <td>{{currentformats.AUformat(con.non_concessional_available_total)}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div><!-- table-responsive -->
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>
<script>
import currentformats from '../../../utils/currentformats'
export default {
    name:'fundnavcontributions',
    components: { 
        DisclaimerV2: () => import('@/views/adviserpanel/elements/DisclaimerV2.vue'),
    },
    data(){
        return{
            isSample:false,
            currentformats:currentformats,
            contributions:[],
            loading:true
        }
    },
    created(){
        this.getContribution()
    },
    methods:{
        getContribution: function(){
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            this.isSample = userdetail['sample'];
            this.$api.funddashboard_api.fundContribution(this.$route.params.fund_code).then(response =>{
                this.contributions = response.data['contributions']
                this.loading=false
            });
        
        },
    }
}
</script>
<style>
.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    color: black;
    background-color: #FFF;
    border-right-color: #DCDFE6;
    border-left-color: #DCDFE6;
}
.el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: black;
}
</style>
<style scoped>
ul.s{
  list-style-type: square;
}
</style>